import React from 'react';
import './floating-input.scss';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TextField from '@mui/material/TextField';
import { commonInputSx } from '../../helper';

interface FloatingInputProps {
  open: boolean;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  indexKey: string;
}

export const FloatingInput: React.FC<FloatingInputProps> = ({
  open,
  onClose,
  value,
  onChange,
  indexKey,
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen={true}
      PaperProps={{
        role: 'dialog',
        'aria-label': 'Success Modal',
      }}
    >
      <div className="floating-input-container">
        <TextField
          label={`Custom Message *`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onClose}
          fullWidth
          margin="normal"
          variant="outlined"
          sx={commonInputSx}
          placeholder={'Enter Custom Message'}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            startAdornment: (
              <span className="floating-input-prefix font-regular">
                {`{{${indexKey}}}`}
              </span>
            ),
          }}
        />
      </div>
    </SwipeableDrawer>
  );
};
